// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CommentSource,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  bugReportId: __t.u64().name("bug_report_id"),
  githubCommentId: __t.option(__t.u64()).name("github_comment_id"),
  get source() {
    return CommentSource;
  },
  authorIdentity: __t.option(__t.identity()).name("author_identity"),
  authorDisplayName: __t.string().name("author_display_name"),
  authorLogin: __t.option(__t.string()).name("author_login"),
  body: __t.string(),
  htmlUrl: __t.option(__t.string()).name("html_url"),
  createdAt: __t.timestamp().name("created_at"),
  githubCreatedAt: __t.option(__t.string()).name("github_created_at"),
});
